<template>
    <div :class="headerClassList" @click="toggleDirection()">
          <!--use the default slot if you want the icon on the right-->
        <slot></slot>
        <i :title="this.direction |titlecase" class="ml-1 mdi" :class="sortIcon + ' ' +  iconColour"></i>
        <!--use this slot if you want the icon on the left-->
        <slot name="right"></slot>
    </div>
</template>

<script>

const SORT_ASC = "asc";
const SORT_DESC = "desc";
const SORT_NONE = "default";

export default {

    name: "SortableColumnHeader",

    props: {
        fieldName: {
            type: String,
            required: true
        },

        headerClassList: {
            type: String,
            required: false,
            default: "cursor-pointer relative"
        },

        sortDirection: {
            type: String,
            required: true
        },

        iconColour: {
            type: String,
            required: false,
            default: "text-gray-400"
        },

        disableDefault: {
            required: false,
            default: false
        },
    },

    data () {
        return {
            direction: this.sortDirection
        };
    },

    watch: {
        sortDirection (newVal) {
            this.direction = newVal;
        }
    },

    computed: {
        sortIcon () {
            switch (this.direction) {
                case SORT_ASC:
                    return "mdi-chevron-double-up";
                case SORT_DESC:
                    return "mdi-chevron-double-down";
                default:
                    return "mdi-unfold-more-horizontal";
            }
        }
    },

    methods: {
        toggleDirection () {
            switch (this.direction) {
                case SORT_ASC:
                    this.direction = SORT_DESC;
                    break;
                case SORT_DESC:
                    this.direction = this.disableDefault ? SORT_ASC : SORT_NONE;
                    break;
                default:
                    this.direction = SORT_ASC;
                    break;
            }
            this.$emit("input", this.direction);
            this.$emit("change", this.fieldName, this.direction);
        }
    }
};
</script>

<style scoped>

</style>
